(() => {
  document.querySelectorAll('[data-lvl-system]').forEach((root) => {
    const steps = root.querySelectorAll('[data-lvl-system-step]');
    const media = Array.from(root.querySelectorAll('[data-lvl-system-media]'));

    const showMedia = (index) => {
      media.forEach((item, mediaIndex) => {
        item.hidden = mediaIndex !== index;
      });
    };

    steps.forEach((step, index) => {
      step.addEventListener('toggle', () => {
        if (step.open) showMedia(index);
      });
    });
  });
})();
